import { usePWA } from "@/contexts/PWAContext";
import { MESSAGE_TYPE, Platform } from "@/utils/enum";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import React, { useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { RootContext } from "../contexts/rootContext";

const SimpleToast: React.FC = () => {
  const { platform } = usePWA()
  const { state } = useContext(RootContext);
  const isLoggedIn = state?.isLoggedIn;
  const queryClient = useQueryClient();
  const router = useRouter();

  useEffect(() => {
    // Only set up listener when user is logged in
    if (!isLoggedIn) {
      return;
    }

    if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      const msg = event?.data;
      const payload = event?.data?.payload;

      if (
        msg?.type !== MESSAGE_TYPE.NOTIFICATION_RECEIVED ||
        !payload ||
        !payload?.notification?.body ||
        platform !== Platform.Desktop
      )
        return;

      const notificationBody = payload.notification.body;

      toast(notificationBody, {
        onClick: () => {
          const route = payload.data?.route;
          const id = payload.data?.id;
          if (route) {
            const link = id ? `/${route}/${id}` : `/${route}`;
            const current = router.asPath;
            if (current !== link) {
              router.push(link);
            }
          }
        },
        autoClose: 20000,
        closeOnClick: true,
        hideProgressBar: true,
        closeButton: false,
      });
    };

    navigator.serviceWorker.addEventListener("message", handleMessage);

    return () => {
      // Clean up listener when user logs out or component unmounts
      navigator.serviceWorker.removeEventListener("message", handleMessage);
    };
  }, [isLoggedIn, router, queryClient]);

  return null;
};

export default SimpleToast;
